import { Button, Flex, Image, Text } from '@chakra-ui/react';

export const Success = () => {
  return (
    <Flex
      flexDir="column"
      w="full"
      p={{ base: 4, lg: 10 }}
      maxH="100dvh"
      h="100%"
      bg="brand.50"
    >
      <Flex
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        gap={6}
        w="full"
        h="100dvh"
      >
        <Image
          src="/images/logo-nexpro-connect.jpeg"
          blendMode="darken"
          h={130}
          objectFit="contain"
        />

        <Text size="2xl" fontWeight="semibold" maxW={400} textAlign="center">
          Seu pedido foi recebido com sucesso e está sendo processado. Verifique
          seu email.
        </Text>

        <Button
          colorScheme="brand"
          size="lg"
          maxW={360}
          w="full"
          as="a"
          href="/"
        >
          Voltar para o site
        </Button>
      </Flex>
    </Flex>
  );
};
